
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const VisionSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div 
          className="max-w-4xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">The Vision</h2>
          
          <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100">
            <p className="text-xl md:text-2xl leading-relaxed text-gray-800 mb-6">
              "We're building the infrastructure that connects daily health to clinical action.
              What began as a health companion is now a value-based care platform — linking behavior to action, 
              action to reimbursement, and outcomes to ROI."
            </p>
            
            <div className="border-t border-gray-100 pt-6 mt-6">
              <p className="text-gray-600 italic">
                Guided by leaders in public health, clinical strategy, and value-based innovation.
              </p>
            </div>
            
            <div className="mt-8 flex items-center justify-center">
              <div className="flex w-full max-w-3xl justify-between">
                <div className="text-center">
                  <div className="h-10 w-10 bg-morgenBlue/10 rounded-full flex items-center justify-center mx-auto mb-2">
                    <span className="text-morgenBlue font-medium">1</span>
                  </div>
                  <p className="text-sm font-medium">Behavior</p>
                </div>
                
                <ArrowRight className="h-5 w-5 text-gray-400 self-center" />
                
                <div className="text-center">
                  <div className="h-10 w-10 bg-morgenTeal/10 rounded-full flex items-center justify-center mx-auto mb-2">
                    <span className="text-morgenTeal font-medium">2</span>
                  </div>
                  <p className="text-sm font-medium">AI</p>
                </div>
                
                <ArrowRight className="h-5 w-5 text-gray-400 self-center" />
                
                <div className="text-center">
                  <div className="h-10 w-10 bg-morgenViolet/10 rounded-full flex items-center justify-center mx-auto mb-2">
                    <span className="text-morgenViolet font-medium">3</span>
                  </div>
                  <p className="text-sm font-medium">Activation</p>
                </div>
                
                <ArrowRight className="h-5 w-5 text-gray-400 self-center" />
                
                <div className="text-center">
                  <div className="h-10 w-10 bg-morgenPurple/10 rounded-full flex items-center justify-center mx-auto mb-2">
                    <span className="text-morgenPurple font-medium">4</span>
                  </div>
                  <p className="text-sm font-medium">ROI</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VisionSection;
